(function(){
    'use strict'

    angular.module('app.impuestosRenta')
    .factory('ImpuestosRentaService', ImpuestosRentaService);

    ImpuestosRentaService.$inject = ['$http', '$q', 'apiSettings'];

    function ImpuestosRentaService($http, $q, apiSettings) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/impuestos-renta';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(impuestoRentaId){

            var url = apiSettings.apiBaseUrl + 'api/impuestos-renta/' + impuestoRentaId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(impuestoRenta){

            impuestoRenta.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/impuestos-renta',  
                method: 'POST',  
                data: impuestoRenta
            });  
            return response;
        };

        function update(impuestoRenta){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/impuestos-renta',  
                method: 'PUT',  
                data: impuestoRenta
            });  
            return response;
        };

        function remove(impuestoRenta){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/impuestos-renta',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: impuestoRenta
            });  
            return response;
        };

    };

})();